<div *ngIf="orderReady">
    <!-- Header -->
    <div class="modal-header">
        <div class="title">
            <h2 class="modal-title">Informations de la commande </h2>
            <h3 class="modal-title" style="text-transform: uppercase">{{ orderDetails.parentId }}</h3>
            <h3 class="modal-title" style="text-transform: uppercase">Web {{ orderDetails.webId }}</h3>
        </div>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <!-- Body  -->
    <div class="modal-body d-flex flex-column">
        <!-- Status of orders -->
        <div class="commande">
            <h5 *ngIf="showDates">Estimation de livraison entre le {{orderDetails.estimateStart | date:'fullDate'}} et
                le {{orderDetails.estimateEnd | date:'fullDate'}}</h5>
            <h5 *ngIf="!showDates">Les dates de livraison n'ont pas encore été estimées</h5>
            <h1 style="color: #EC008C" *ngIf="role === 'Provider'">{{priceProviderTotal.toFixed(2)}}
                {{orderDetails.currencySymbol}} </h1>
            <h1 style="color: #EC008C" *ngIf="role === 'Shop' || role === 'Admin'">{{orderDetails.totalPrice}}
                {{orderDetails.currencySymbol}}</h1>

            <p *ngIf="role === 'Provider'">HT</p>
            <p *ngIf="role === 'Shop' || role === 'Admin'">TTC</p>

            <p class="status-order cancelled"
                *ngIf="orderDetails.status === 'cancelled' || orderDetails.status === 'to-refund' || orderDetails.status === 'refunded'">
                Annulé</p>
            <p class="status-order pending"
                *ngIf="orderDetails.status === 'pending' || orderDetails.status === 'on-hold'">À payer</p>
            <p class="status-order processing" *ngIf="orderDetails.status === 'to-process'">En attente</p>
            <p class="status-order processing" *ngIf="orderDetails.status === 'processing'">En préparation</p>
            <p class="status-order completed" *ngIf="orderDetails.status === 'completed'">Livré</p>
        </div>
        <!-- 2 tabs -->
        <nav ngbNav #nav="ngbNav" class="nav-tabs list-info">
            <!-- Order tab -->
            <ng-container ngbNavItem>
                <a ngbNavLink>Commande</a>
                <ng-template ngbNavContent>
                    <div *ngFor="let product of orderDetails.products" class="d-flex d-flex-row mb-70">
                        <div class="img">
                            <div *ngIf="product.options.image_file_name; else defaultImage">
                                <img src="{{S3_SCREENSHOT_PUBLIC_URL}}{{product.options.image_file_name}}.png" alt="">
                            </div>
                            <ng-template #defaultImage>
                                <img *ngIf="product.image" src="{{FS}}{{product.image}}" alt="">
                            </ng-template>
                        </div>
                        <div class="details">
                            <div class="list-grid-3">
                                <p><span class="f-w-600">{{product.name}}</span></p>
                                <p><span class="f-w-600">Qté:</span> {{product.quantity}}</p>
                                <p *ngIf="role !== 'Provider'"><span class="f-w-600">Total:</span>
                                    {{orderDetails.totalPrice}}€</p>
                            </div>
                            <div style="margin-bottom: 1rem">
                                <p>{{orderDetails.provider}}</p>
                            </div>
                            <div class="container-options">
                                <div *ngFor="let option of productOption[product.id]" class="content-option">
                                    <p class="option_name">{{option.label}}</p>
                                    <p class="option_value">{{option.value}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
            <!-- Payment and delivery -->
            <ng-container ngbNavItem>
                <a ngbNavLink>Réglement et livraison</a>
                <ng-template ngbNavContent>
                    <div class="d-flex flex-column w-100 mb-30">
                        <h5>INFORMATION CLIENT</h5>
                        <div class="list-grid-4">
                            <h6>Nom</h6>
                            <h6>Identifiant</h6>
                            <h6>Email</h6>
                            <h6>Téléphone</h6>
                            <p>{{orderDetails.client.firstName}} {{orderDetails.client.lastName}}</p>
                            <p>{{orderDetails.clientId}}</p>
                            <p>{{orderDetails.client.email}}</p>
                            <p>{{orderDetails.client.telephone}}</p>
                        </div>
                    </div>

                    <div class="d-flex flex-column w-100 mb-30">
                        <h5>INFORMATION FACTURATION</h5>
                        <div class="list-grid-1_2">
                            <div>
                                <h6>Adresse de facturation</h6>
                                <p>{{orderDetails.billing.first_name}} {{orderDetails.billing.last_name}}</p>
                                <p>{{orderDetails.billing.address_1}}</p>
                                <p *ngIf="orderDetails.billing.address_2 != 'N/A'">{{orderDetails.billing.address_2}}
                                </p>
                                <p>{{orderDetails.billing.postcode}} {{orderDetails.billing.city}}</p>
                                <p></p>
                            </div>
                            <div>
                                <h6>Moyen de paiement</h6>
                                <!-- <p>{{orderDetails.paymentMethod}}</p> -->
                                <p>{{orderDetails.paymentMethodTitle}}</p>
                            </div>
                            <div>
                                <h6>État du paiement</h6>
                                <p
                                    *ngIf="orderDetails.status === 'to-process' || orderDetails.status === 'processing' || orderDetails.status === 'completed'">
                                    Commande payée</p>
                                <p *ngIf="orderDetails.status === 'cancelled'">Paiement refusé ou non reçu</p>
                                <p *ngIf="orderDetails.status === 'pending' || orderDetails.status === 'on-hold'">En
                                    attente de paiement</p>
                                <p *ngIf="orderDetails.status === 'to-refund'">Commande à rembourser au client</p>
                                <p *ngIf="orderDetails.status === 'refunded'">Commande remboursée</p>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column w-100 mb-30">
                        <h5>INFORMATION LIVRAISON</h5>
                        <div class="list-grid-1_2">
                            <div *ngIf="orderDetails.deliveryType === 'CLICK_AND_COLLECT'">
                                <p><strong>{{dataPDF.shop.name}}</strong></p>
                                <p>{{dataPDF.shop.address}}</p>
                                <p>{{dataPDF.shop.cp}} {{dataPDF.shop.city}}</p>
                            </div>
                            <div *ngIf="orderDetails.deliveryType === 'HOME_DELIVERY'">
                                <h6>Adresse de livraison</h6>
                                <p>{{orderDetails.shipping.first_name}} {{orderDetails.shipping.last_name}}</p>
                                <p>{{orderDetails.shipping.address_1}}</p>
                                <p>{{orderDetails.shipping.address_2}}</p>
                                <p>{{orderDetails.shipping.postcode}} {{orderDetails.shipping.city}}</p>
                            </div>
                            <div>
                                <h6>Mode de livraison</h6>
                                <p>{{orderDetails.deliveryType === "CLICK_AND_COLLECT" ? 'Click and collect' :
                                    'Livraison à domicile'}}
                                </p>
                            </div>
                            <div>
                                <h6>État de la commande</h6>
                                <p
                                    *ngIf="orderDetails.status === 'cancelled' || orderDetails.status === 'to-refund' || orderDetails.status === 'refunded'">
                                    <span class="span_block">Commande annulée</span>
                                    <span class="span_block"
                                        *ngIf="orderDetails.status === 'to-refund' || orderDetails.status === 'refunded'">
                                        <span class="text-bold">Raison: </span>
                                        {{orderDetails.cancel.detail}}</span>
                                </p>
                                <p *ngIf="orderDetails.status === 'pending' || orderDetails.status === 'on-hold'">
                                    Commande en attente de paiement</p>
                                <p *ngIf="orderDetails.status === 'to-process'">
                                    Commande
                                    <span *ngIf="orderDetails.validated" class="c_green">validée</span>
                                    <span *ngIf="!orderDetails.validated" class="c_red">non validée</span>
                                    en attente de la fin du délai légal de retractation
                                </p>
                                <p *ngIf="orderDetails.status === 'processing'">Commande en cours de préparation</p>
                                <p *ngIf="orderDetails.status === 'completed'">Commande livrée</p>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column w-100 mb-30" *ngIf="orderDetails.pose || orderDetails.cote">
                        <h5>INFORMATION POSE / PRISE DE CÔTES</h5>
                        <div class="list-grid-2">
                            <div *ngIf="orderDetails.pose">
                                <h6>Adresse d'installation</h6>
                                <p>{{orderDetails.installation.installation_firstName}}
                                    {{orderDetails.installation.installation_lastName}}</p>
                                <p>{{orderDetails.installation.installation_addr}}</p>
                                <p>{{orderDetails.installation.installation_addr2}}</p>
                                <p>{{orderDetails.installation.installation_postcode}}
                                    {{orderDetails.installation.installation_city}}</p>
                            </div>
                            <div *ngIf="orderDetails.cote">
                                <h6>Adresse de la prise de côtes</h6>
                                <p>{{orderDetails.dimension.dimension_firstName}}
                                    {{orderDetails.dimension.dimension_lastName}}</p>
                                <p>{{orderDetails.dimension.dimension_addr}}</p>
                                <p>{{orderDetails.dimension.dimension_addr2}}</p>
                                <p>{{orderDetails.dimension.dimension_postcode}}
                                    {{orderDetails.dimension.dimension_city}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column w-100 mb-30">
                        <h5>Note de commande</h5>
                        <p *ngIf="orderDetails.orders_comments.value">{{orderDetails.orders_comments.value}}</p>
                        <p *ngIf="!orderDetails.orders_comments.value">Aucune note du client.</p>
                    </div>

                </ng-template>
            </ng-container>
            <div class="btn-pdf" title="Télécharger la facture" (click)="generatePdf(false);"
                *ngIf="['Provider', 'Shop', 'Admin'].includes(role)">
                {{ role == 'Provider' ? 'Détail commande' : 'Facture' }}
                <img src="../../../assets/images/download.png" alt="">
            </div>

            <div class="btn-pdf" title="Télécharger la facture" (click)="generatePdf(true);"
                *ngIf="role !== 'Provider'">
                Frais site e-commerce
                <img src="../../../assets/images/download.png" alt="">
            </div>
        </nav>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
</div>

<!-- PDF -->
<div *ngIf="activePdfTemplate" id="PDF" class="main-container">
    <html>

    <head>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>Commande n°{{orderDetails.parentId}} du {{orderDetails.date | date:'fullDate'}}</title>
    </head>

    <body id="{{network}}">
        <header>
            <div class="left-header">
                <img *ngIf="network === 'MDM'" class="logo MDM" src="/assets/images/logo/logo-mdmi.png" alt="">
                <img *ngIf="network === 'SM'" class="logo SM" src="/assets/images/logo/logo-smi.png" alt="">

                <div class="shopInfo" *ngIf="!isHidden">
                    <p><strong>{{dataPDF.shop.name}}</strong></p>
                    <p>{{dataPDF.shop.address}}</p>
                    <p>{{dataPDF.shop.cp}} {{dataPDF.shop.city}}</p>
                    <p>Tel. : {{dataPDF.shop.phone}}</p>
                    <p>Email : {{dataPDF.shop.email}}</p>
                </div>

                <div class="shopInfo" *ngIf="isHidden">
                    <p><strong>{{network == 'MDM' ? "MDM-I" : "SM-I"}}</strong></p>
                    <p>
                        56 Avenue Des Combattans AFN
                        <br>
                        13700 Marignane
                    </p>
                </div>
            </div>

            <div class="right-header">
                <div class="order colorBorder">
                    <p class="numOrder"><strong>Commande n°{{orderDetails.parentId}}</strong></p>
                    <p class="numOrder"><strong>Web n°{{orderDetails.webId}}</strong></p>
                    <p>Date de commande: {{orderDetails.date | date:'fullDate'}}</p>
                    <p>Téléphone : {{orderDetails.billing.phone}}</p>
                </div>
                <div class="clientInfo">
                    <p><strong>{{orderDetails.billing.first_name}} {{orderDetails.billing.last_name}}</strong></p>
                    <p>
                        {{orderDetails.billing.address_1}}
                        <br>
                        {{orderDetails.billing.postcode}}
                        {{orderDetails.billing.city}}
                    </p>
                </div>
            </div>


        </header>
        <div class="deliveryInfo" *ngIf="!isHidden">
            <p>Délais livraison : 4 à 6 semaines </p>
            <p *ngIf="orderDetails.deliveryType === 'CLICK_AND_COLLECT'">Livraison : {{dataPDF.shop.address}},
                {{dataPDF.shop.cp}} {{dataPDF.shop.city}}</p>
            <p *ngIf="orderDetails.deliveryType === 'HOME_DELIVERY'">Livraison : {{orderDetails.billing.address_1}},
                {{orderDetails.billing.postcode}}, {{orderDetails.billing.city}}</p>
            <p>Mode de livraison: {{orderDetails.deliveryType === "CLICK_AND_COLLECT" ? 'Click and collect' :
                'Livraison à domicile'}}
            </p>
        </div>

        <table class="blueTable">
            <thead class="colorThead">
                <tr>
                    <th colspan="1" *ngIf="!isHidden">Produit</th>
                    <th colspan="1">Qté</th>
                    <th colspan="1">Désignation</th>
                    <th colspan="1">Ref</th>
                    <th colspan="1" *ngIf="(role === 'Shop' || role === 'Admin') && !isHidden">Prix d'achat</th>
                    <th colspan="1" *ngIf="role === 'Provider' && !isHidden">Prix de vente HT</th>
                    <th *ngIf="(role === 'Shop' || role === 'Admin')" colspan="1">Prix HT</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="!isHidden">
                    <div *ngFor="let product of orderDetails.products; let index = index">
                        <tr>
                            <td>
                                <div *ngIf="product.options.image_file_name; else defaultProductImage">
                                    <img src="{{S3_SCREENSHOT_PUBLIC_URL}}{{product.options.image_file_name}}.png" alt="">
                                </div>
                                <ng-template #defaultProductImage>
                                    <img *ngIf="product.image" src="{{FS}}{{product.image}}" alt="">
                                </ng-template>
                            </td>
                            <td>
                                <strong>{{product.quantity}}</strong>
                            </td>
                            <td>
                                <div class="product-description">
                                    <strong>{{productDetailSet[index].name}}</strong>
                                </div>
                            </td>
                            <td></td>
                            <td>
                                <strong>
                                    {{(product.price / getCoefFromSubCat(product)).toFixed(2)}}
                                </strong>

                            </td>
                            <td *ngIf="(role === 'Shop' || role === 'Admin')">
                                <strong>{{orderDetails.priceDetail.subTotal.toFixed(2)}}</strong>
                            </td>

                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td class="info">
                                <p *ngFor="let option of productOption[product.id]">
                                    <strong>{{option.label}}</strong>: {{option.value}} {{option.direction}}
                                </p>
                            </td>
                            <td class="info">
                                <p *ngFor="let option of productOption[product.id]">
                                    {{option.infoprovider || "\u00A0"}}
                                </p>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                    </div>
                </ng-container>
                <ng-container *ngIf="isHidden">
                    <tr>
                        <td class="info">
                            <div class="product-options">
                                <p *ngIf="isHidden"><strong>Frais site e-commerce Commande n° {{orderDetails.parentId}}
                                        /
                                        Web n°{{orderDetails.webId}}</strong></p>
                            </div>
                        </td>
                        <td>
                            <strong>1</strong>
                        </td>
                        <td>
                            <strong>{{getCommissionPriceDetails().HT}}</strong>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <div class="payment break">
            <div class="paymentInfo" *ngIf="!isHidden">
                <p><strong>Mode de paiement</strong>: {{orderDetails.paymentMethodTitle}}</p>
            </div>
            <div class="priceInfo colorBorder">
                <div *ngIf="(role === 'Shop' || role === 'Admin') && !isHidden">
                    <p>Prix d'achat HT:</p>
                    <p class="price">{{getTotalPriceSold(orderDetails.products)}} €</p>
                </div>
                <div *ngIf="(role === 'Shop' || role === 'Admin') && !isHidden">
                    <p>Prix de vente HT:</p>
                    <p class="price">{{orderDetails.priceDetail.subTotal.toFixed(2)}} €</p>
                </div>
                <div *ngIf="(role === 'Shop' || role === 'Admin') && !isHidden">
                    <p>Livraison en magasin:</p>
                    <p class="price">{{orderDetails.priceDetail.delivery}} €</p>
                </div>
                <div *ngIf="(role === 'Shop' || role === 'Admin') && !isHidden">
                    <p>Prise de Cote:</p>
                    <p class="price">{{orderDetails.cote ? orderDetails.priceDetail.dimension != 0 ?
                        orderDetails.priceDetail.dimension + "€": "Forfait" : "0 €"}}</p>
                </div>
                <div *ngIf="(role === 'Shop' || role === 'Admin') && !isHidden">
                    <p>Pose:</p>
                    <p class="price">{{orderDetails.pose ? ( orderDetails.priceDetail.installation != 0 ?
                        orderDetails.priceDetail.installation + "€" : "Forfait" ) : "0 €"}}</p>
                </div>
                <div *ngIf="(role !== 'Shop' || role === 'Admin') && !isHidden">
                    <p>Total HT:</p>
                    <p class="price">{{priceProviderTotal.toFixed(2)}} €</p>
                </div>

                <div *ngIf="isHidden">
                    <p><strong>Total HT:</strong></p>
                    <p class="price"><strong>{{getCommissionPriceDetails().HT}} €</strong></p>
                </div>

                <div *ngIf="isHidden">
                    <p><strong>TVA:</strong></p>
                    <p class="price"><strong>{{getCommissionPriceDetails().TVA}}
                            €</strong></p>
                </div>

                <div *ngIf="isHidden">
                    <p><strong>Prix TTC:</strong></p>
                    <p class="price"><strong>{{getCommissionPriceDetails().TTC}}
                            €</strong></p>
                </div>

                <div *ngIf="(role === 'Shop' || role === 'Admin') && !isHidden">
                    <p>Total vente HT:</p>
                    <p class="price">{{orderDetails.priceDetail.totalHT.toFixed(2)}} €</p>
                </div>
                <div *ngIf="(role === 'Shop' || role === 'Admin') && !isHidden">
                    <p>Total vente TVA:</p>
                    <p class="price">{{orderDetails.priceDetail.tva}} €</p>
                </div>
                <div *ngIf="(role === 'Shop' || role === 'Admin') && !isHidden">
                    <p><strong>Total vente TTC:</strong></p>
                    <p class="price"><strong>{{orderDetails.totalPrice}} €</strong></p>
                </div>
            </div>
        </div>

        <div class="signInfo break" *ngIf="!isHidden">
            <div class="bdc-ct">
                <p><strong>Bon pour commande</strong></p>
            </div>
            <div class="info-ct">
                <p class="from">Fait à:</p>
                <p class="at">le:</p>
                <p class="sign">Signature du client:</p>
            </div>
        </div>
    </body>

    </html>
</div>